export default {
  LOAD_COMPETENCY_OVERVIEW_PAGE_START: 'LoadCompetencyOverviewPageStart',
  LOAD_COMPETENCY_OVERVIEW_PAGE_END: 'LoadCompetencyOverviewPageEnd',
  SELECT_COMPETENCY_OVERVIEW_PAGE_TAB: 'SelectCompetencyOverviewPageTab'
};